import formatCurrency from "@/utils/formatCurrency";

const CashFlowSummary = ({ incomes, expenses, savings }) => {
  const totalIncome = incomes.reduce((sum, i) => sum + (i.is_monthly ? i.monthly_amount * 12 : i.yearly_amount), 0);
  const totalExpenses = expenses.reduce((sum, e) => sum + (e.is_monthly ? e.monthly_amount * 12 : e.yearly_amount), 0);
  const totalSavings = savings.reduce((sum, s) => sum + (s.is_monthly ? s.monthly_amount * 12 : s.yearly_amount), 0);
  const surplus = totalIncome - totalExpenses - totalSavings;

  return (
    <div className="finance-card" data-testid="cashflow-summary">
      <h3 className="section-title">Cash Flow Summary (Yearly)</h3>
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Total Income</span>
          <span className="summary-value income" data-testid="total-income">₹{formatCurrency(totalIncome)}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Net Outflow</span>
          <span className="summary-value expense" data-testid="total-outflow">₹{formatCurrency(totalExpenses)}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Total Savings</span>
          <span className="summary-value savings" data-testid="total-savings">₹{formatCurrency(totalSavings)}</span>
        </div>
        <hr className="border-gray-200" />
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center pt-2 gap-1">
          <span className="text-base sm:text-xl font-bold text-gray-800">Total Available Surplus for New Investment</span>
          <span className={`text-2xl sm:text-3xl font-bold ${surplus >= 0 ? "text-teal-600" : "text-red-500"}`} data-testid="surplus">
            ₹{formatCurrency(surplus)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CashFlowSummary;
